import { FormFieldGroup, FormInput, FormLabel, FormLabelDescription, Text } from '$components'
import { BusinessHoursInput } from '$components'
import { Input } from '.'

export function CreateLocationFormContent() {
  return (
    <div className="flex flex-col gap-stack-section flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.Name}>
          Name
        </FormLabel>

        <FormLabelDescription>
          Give your location a clear name that your team and clients will easily understand.
        </FormLabelDescription>

        <FormInput
          name={Input.Name}
          placeholder="Enter location name..."
        />
      </FormFieldGroup>

      <Text
        type="h4"
        className="mt-stack-roomy"
      >
        Address
      </Text>

      <FormFieldGroup>
        <FormLabel htmlFor={`${Input.Address}.${Input.AddressLineOne}`}>
          Address Line 1
        </FormLabel>

        <FormInput
          name={`${Input.Address}.${Input.AddressLineOne}`}
          placeholder="Enter address line 1..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={`${Input.Address}.${Input.AddressLineTwo}`}>
          Address Line 2
        </FormLabel>

        <FormInput
          name={`${Input.Address}.${Input.AddressLineTwo}`}
          placeholder="Enter address line 2... (optional)"
        />
      </FormFieldGroup>

      <div className="grid grid-cols-2 gap-stack-roomy">
        <FormFieldGroup>
          <FormLabel htmlFor={`${Input.Address}.${Input.AddressCity}`}>
            City
          </FormLabel>

          <FormInput
            name={`${Input.Address}.${Input.AddressCity}`}
            placeholder="Enter city..."
          />
        </FormFieldGroup>

        <FormFieldGroup>
          <FormLabel htmlFor={`${Input.Address}.${Input.AddressPostCode}`}>
            Post Code
          </FormLabel>

          <FormInput
            name={`${Input.Address}.${Input.AddressPostCode}`}
            placeholder="Enter post code..."
          />
        </FormFieldGroup>
      </div>

      <FormFieldGroup>
        <FormLabel htmlFor={`${Input.Address}.${Input.AddressCountry}`}>
          Country
        </FormLabel>

        <FormInput
          name={`${Input.Address}.${Input.AddressCountry}`}
          placeholder="Enter country..."
        />
      </FormFieldGroup>

      <div>
        <Text
          type="h4"
          className="mb-stack-dense"
        >
          Business Hours
        </Text>

        <FormLabelDescription className="mb-stack-roomy">
          Set the hours when this location is open for business.
        </FormLabelDescription>

        <BusinessHoursInput name={Input.BusinessHours} />
      </div>
    </div>
  )
}
